// Full-screen fan control route — the standalone /device page / small-screen
// fallback. Since 2026-10-03 it draws the PHONE'S dial
// (ui/shared/controls/FanDialControl), like the desktop fan card, so every
// shell shows one fan control.

import React from 'react';
import { Box, Typography } from '@mui/material';
import DeviceShell from '../../components/DeviceShell';
import FanDialControl from '../../../shared/controls/FanDialControl';

export default function FanScreen({ device }) {
  return (
    <DeviceShell title={device.DeviceName || device.UniqueNumber}>
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <FanDialControl device={device} size={300} />
        <Typography color="text.secondary" sx={{ mt: 1, fontSize: 13 }}>
          Drag around the dial to set speed
        </Typography>
      </Box>
    </DeviceShell>
  );
}
